// https://vuex.vuejs.org/en/getters.html

export default {
  appVersion(state) {
    return state.packageVersion;
  },
  getIsEditingMode(state) {
    return state.isEditingMode;
  },
  getSnackbarInstance(state) {
    return state.snackbar;
  },
  getLoggedUser(state) {
    return state.loggedUser;
  },
  getTabs(state) {
    return state.tabs;
  },
  getDashboardFilters(state) {
    return state.dashboardFilters;
  },
  getStrategiesFilters(state) {
    return state.strategiesFilters;
  },
  getStrategiesProductionFilters(state) {
    return state.strategiesProductionFilters;
  },
  getStrategiesPlanningFilters(state) {
    return state.strategiesPlanningFilters;
  },
  getStrategiesArchivedFilters(state) {
    return state.strategiesArchivedFilters;
  },
  getApproachesFilters(state) {
    return state.approachesFilters;
  },
  getFiringHistoryFilters(state) {
    return state.firingHistoryFilters;
  },
  getFiringFilters(state) {
    return state.firingFilters;
  },
  getClientsBaseFilters(state) {
    return state.clientsBaseFilters;
  },
  getReportsFilters(state) {
    return state.reportsFilters;
  },
  getForecastsFilters(state) {
    return state.forecastsFilters;
  },
  getEventsFilters(state) {
    return state.eventsFilters;
  },
  getPotentialsFilters(state) {
    return state.potentialsFilters;
  },
  getDebtTreeFilters(state) {
    return state.debtTreeFilters;
  }, 
  getConfigurations(state) {
      return state.configurations
  },
  getApproachesFlowFilters(state) {
    return state.approachesFlowFilters;
  },
  getDebtTreeStimulus(state) {
    return state.debtTreeStimulus;
  },
  getManualStrategy(state) {
    return state.manualStrategy;
  },
  getPreparesDailyFilters(state) {
    return state.preparesDailyFilters;
  },
  getStimulusHistoryFilters(state) {
    return state.stimulusHistoryFilters;
  },
  getConfig: (state) => (configName) => {
      let _return = null
      let configFiltered = state.configurations.filter(c => c.key == configName)

      if (configFiltered.length) {
          _return = configFiltered[0].value
      }

      return _return
  },
  isQA: (state) => {
    if (!state.loggedUser || !state.loggedUser.roles) return false;
    return state.loggedUser.roles.includes('QA');
  },
  isWppTemplateAdmin: (state) => {
    if (!state.loggedUser || !state.loggedUser.roles) return false;
    return state.loggedUser.roles.includes('wpp_template_admin');
  },
};
